// Route classification helpers, backed by the shared routeManifest.json so the
// app and the build scripts (sitemap, prerender list, strip-dynamic) agree.

import manifest from "./routeManifest.json";

export const PUBLIC_ROUTES = manifest.publicRoutes;
export const PRIVATE_ROUTE_PREFIXES = manifest.privateRoutePrefixes;
export const STRIP_DYNAMIC_ROUTES = manifest.stripDynamicRoutes;

/** Strip a trailing slash (except root) for comparisons. */
/** @param {string} pathname @returns {string} */
export const normalizePath = (pathname) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
};

/** Canonical trailing-slash form ("/faq" -> "/faq/", "/" -> "/"). */
/** @param {string} pathname @returns {string} */
export const withTrailingSlash = (pathname) => {
  const p = normalizePath(pathname);
  return p === "/" ? "/" : `${p}/`;
};

/** True if the path is under a private/authenticated/transactional prefix. */
/** @param {string} pathname @returns {boolean} */
export const isPrivateRoute = (pathname) => {
  const p = normalizePath(pathname);
  return PRIVATE_ROUTE_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
};
